import { Event as ThreediEvent } from "@nens/threedi/openapi-client";

import EventDetailsAccordion from "./EventDetailsAccordion";
import EventFileDetails from "./EventFileDetails";

type EventDetailsVisualisationProps = {
  type: "initial" | "simulation";
  events: ThreediEvent;
};

const spaceAfter = [
  "file",
  "boundary",
  "raster",
  "sources",
  "structure",
  "timeseries",
  "initial",
  "groundwater",
  "waterlevel",
  "lizard",
  "local",
  "memorystructure",
  "obstacle",
  "tablestructure",
];
const translate = [
  ["oned", "1D "],
  ["twod", "2D "],
];

function prettifyTitle(title: string) {
  let titleCopy = title.toLocaleLowerCase();
  spaceAfter.forEach((spaceAfterString) => {
    titleCopy = titleCopy.replace(spaceAfterString, spaceAfterString + " ");
  });
  translate.forEach((translate) => {
    titleCopy = titleCopy.replace(translate[0], translate[1]);
  });
  return titleCopy[0].toUpperCase() + titleCopy.slice(1);
}

function EventDetailsVisualisation({ type, events }: EventDetailsVisualisationProps) {
  const eventsKeyArray = Object.keys(events);
  const excludeKeys = [
    "timeseriesrain",
    "laterals",
    "wind",
    "breach",
    "savedstates",
    "initialTwodwaterlevel",
    "initialTwodwaterraster",
    "initialOnedwaterlevel",
    "initialOnedwaterlevelpredefined",
    "initialGroundwaterlevel",
    "initialGroundwaterraster",
    "initialSavedstate",
  ]; // Make sure to add to this array if you add a new visualization
  const filteredKeyArray = eventsKeyArray.filter((key) => {
    if (excludeKeys.indexOf(key) !== -1) return false; // Remove already visualised values
    if (type === "initial" && !key.includes("initial")) return false; // Show only initial when type is initial
    if (type !== "initial" && key.includes("initial")) return false; // Dont show initial when type is not initial

    const value = events[key as keyof ThreediEvent];
    return Array.isArray(value) ? value.length : value; // Remove undefined values
  });

  const fileKeyArray: string[] = [];
  const nonFileKeyArray: string[] = [];

  const fileKeys = [
    "filerastersourcessinks",
    "filetimeseriessourcessinks",
    "filetimeseriesleakage",
    "filerasterleakage",
    "filerasterrain",
    "filetimeseriesrain",
    "filelaterals",
    "fileboundaryconditions",
    "filestructurecontrols",
  ];

  filteredKeyArray.forEach((key) => {
    const pushArray = fileKeys.includes(key) ? fileKeyArray : nonFileKeyArray;
    pushArray.push(key);
  });

  return (
    <>
      <EventFileDetails events={events} prettifyTitle={prettifyTitle} eventKeys={fileKeyArray} />
      <EventDetailsAccordion
        events={events}
        prettifyTitle={prettifyTitle}
        eventKeys={nonFileKeyArray}
      />
    </>
  );
}

export default EventDetailsVisualisation;
